/*global chrome*/
import React, { Component } from "react";
import Slider from "react-slick";

class VideoTuts extends Component {
  render() {
    const Turorialvideos = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: true,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: true,
          },
        },
      ],
    };

    return (
      <>    
      <div className="video-section left-arrow-slider slider-dot-arrow">          
            <h2
              className="primary-heading text-center"
              dangerouslySetInnerHTML={{ __html: this.props.title }}
            />  
            <Slider {...Turorialvideos}>
              {[
                "FjFbsgJ_0tI",
                "CNi0B1HxCkg",
                "V2XWBjSYVFU",
                "AMROpv0ny84",
                "echtKnjztNQ",
                "86xTx4qBwdk",
              ].map((videoId, index) => (
                <div key={index}>
                  <div className="iframe-video-wrapper">
                    <iframe
                      className="iframe-video"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title={`Student Testimonial Video ${index + 1}`}
                      allowFullScreen
                    />
                  </div>
                </div>
              ))}
            </Slider>
            <div className="d-flex justify-content-center">
                <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/@LanguageAcademyPTE"
                className="primary-btn"
              >
                VIEW ALL VIDEOS <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
              </a>
            </div>
      </div>
      </>
    );
  }
}

export default VideoTuts;
